module.exports = __webpack_public_path__ + "static/media/04_BischofOverbeck_webfinal.0449f4a8.jpg";